import React from "react";

import { LocationProvider } from "./LocationContext";
import { RaceProvider } from "./RaceContext";
import { YearProvider } from "./YearContext";

const ContextProvider = ({ children }) => {
  return (
    <>
      <LocationProvider>
        <RaceProvider>
          <YearProvider>{children}</YearProvider>
        </RaceProvider>
      </LocationProvider>
    </>
  );
};

export default ContextProvider;
